import React from 'react'
import SubscriptionSuccess from '../../components/SubscriptionSuccess/SubscriptionSuccess'

export default function SubscriptionSuccessPage() {
  return <SubscriptionSuccess />
}
